import { Component, OnInit, OnDestroy } from '@angular/core';
import { SolicitarServicioService } from '../service/solicitar-servicio.service';
import { Nexus } from 'src/app/util/nexus';
import { Title } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { modalService} from '../service/modal.service';
import * as InfoNavigate from '../util/detect-navigator/navigator-user-agent';
import { ServiciosExternosService } from '../service/servicios-externos.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],

})
export class LoginComponent implements OnInit, OnDestroy {

  codcliente : string = environment.CODCLIENTE 
  flagCliente : boolean
  logo = {
    url: environment.LOGO_INICIO_SESION.URL,
    alt: environment.LOGO_INICIO_SESION.ALT,
    url_img_1: environment.IMAGEN_SESION_1.URL,
    alt_img_1: environment.IMAGEN_SESION_1.ALT,
    url_img_2: environment.IMAGEN_SESION_2.URL,
    alt_img_2: environment.IMAGEN_SESION_2.ALT
  } 
  constructor(
    private titleService: Title,
    private solicitarServicioService: SolicitarServicioService,
    private modalSpinner:modalService,
    private serviciosExternos: ServiciosExternosService
  ) {}


  ngOnInit() {
  
    this.flagCliente = environment.CODCLIENTE  === 'NXVSENIORTAXI' ? true : false
    this.modalSpinner.ocultarModal();
    this.titleService.setTitle(environment.NOMBRE_EMPRESA);
    Nexus.geolocate();
    Nexus.getCountryClient(this.solicitarServicioService);
    this.serviciosExternos.getIpId().subscribe((data: string) => {
      InfoNavigate.setIpId(data);
    }, (error => {
      InfoNavigate.setIpId(error.error.text);
    }));
  }

  validarVersionNavegador() {
    let oldIE;
    if (document.all && !window.atob) {
      oldIE = true;
      alert("Versión de navegador no soportado");
    }

    if (oldIE) {
      window.location.href = "assets/error/errorCompatibilidad.html";

    }
  }

  ngOnDestroy(){
    this.modalSpinner.cargar();
  }
}
